import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import Page from './Page';

const PhpClassGenerator: FC = () => {
   
    return (
        <Page
            title="utils.sh"
        >
            <h2>Programming tools</h2>
            <ul>
                <li>
                    <Link to="/php/class/generate">PHP Setter/Getter Generator</Link>
                </li>
            </ul>
            <h2>QR Code tools</h2>
            <ul>
                <li>
                    <Link to="/qrcode/website">QR Code Generator for websites</Link>
                </li>
                <li>
                    <Link to="/qrcode/wifi">QR Code Generator for WiFi</Link>
                </li>
            </ul>
        </Page>
    );
}

export default PhpClassGenerator;